function References() {
  return (
    <div id="section45">
      <h3>References</h3>
        <ul>
          <li className="bullet-item">Reference year</li>
          <li className="bullet-item">Journal</li>
          <li className="bullet-item">Reference: the identifier of the reference (PMID or NCTID)</li>
          <li className="bullet-item">Reference type: publication (PMID) or clinical trial (NCTID)</li>
          <li className="bullet-item">
            Citation counts: indicate the number of citations per article obtained from <a href="https://icite.od.nih.gov/" >iCite</a>
          </li>
        </ul>
    </div>
  );
}
export default References;
